export default __webpack_public_path__ + "img/37.d5d6ff.png";